import { render, staticRenderFns } from "./ScholarPanel.vue?vue&type=template&id=7d44e870&scoped=true"
import script from "./ScholarPanel.vue?vue&type=script&lang=js"
export * from "./ScholarPanel.vue?vue&type=script&lang=js"
import style0 from "./ScholarPanel.vue?vue&type=style&index=0&id=7d44e870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44e870",
  null
  
)

export default component.exports